import BuyNowButton from './buynowbutton';
const Product = ({
  image,
  name,
  description,
  price,
  priceid,
  productid,
  category,
}) => {
  return (
    <div className='product-card-wrap'>
      <div className='product-card' key={productid}>
        <div className='product-image'>
          <img src={image} alt={name} />
        </div>
        <h3 className='product-title'>{name}</h3>
        <div>
          <p className='product-description'>{description}</p>
          <p className='product-price'>${price}.00</p>
        </div>
        <div class="buynow-section">
          <BuyNowButton productPriceId={priceid} />
        </div>
      </div>
      <div className='product-barcode'>
        <p>{priceid.substr(15)}</p>
      </div>
    </div>
  );
};

export default Product;
